import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Typo, theme } from '../../../../ui';
import { shadeColor } from '../../../../ui/theme/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  background: ${({ $bgColor }) => $bgColor};
  border: 2px dashed ${({ $borderColor }) => $borderColor};
  border-radius: 8px;
  min-height: 120px;
  width: 100%;
  text-align: center;
`;

/**
 * UnsupportedContentPlaceholder component - Shows placeholder when module has unsupported content
 * Used in edit mode to indicate content that cannot be displayed/played
 *
 * @param {Object} props
 * @param {string} props.moduleType - The type of module (for translation key)
 * @param {React.Component} props.IconComponent - The icon component to render
 * @param {string} props.themeColor - Theme color for styling
 * @param {string} [props.title] - Custom title (overrides translation)
 * @param {string} [props.description] - Custom description (overrides translation)
 */
const UnsupportedContentPlaceholder = ({ moduleType, IconComponent, themeColor, title, description }) => {
  const { t } = useTranslation();

  const displayTitle = title || t(`editCourse.unsupportedContent.${moduleType}`, { defaultValue: t('editCourse.unsupportedContent.default') });
  const displayDescription = description || t('editCourse.unsupportedContent.description');

  return (
    <Container $bgColor={shadeColor(themeColor, 0.97)} $borderColor={shadeColor(themeColor, 0.7)}>
      <IconComponent size='medium' color={theme.colors.WARNING_YELLOW} />
      <Typo.TextTitle>{displayTitle}</Typo.TextTitle>
      <Typo.SmallText color={theme.colors.NEU_600}>{displayDescription}</Typo.SmallText>
    </Container>
  );
};

export default UnsupportedContentPlaceholder;
